/* Sudara: reveal on scroll */
(function(){
  var SEL='.sd-reveal,.sd-reveal-pop,.sd-draw,.sd-arch-in';
  function show(el){el.classList.add('is-in');}
  function scan(root){
    var els=(root||document).querySelectorAll(SEL);
    if(!('IntersectionObserver' in window)){els.forEach(show);return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -5% 0px'});
    els.forEach(function(el){if(!el.classList.contains('is-in'))io.observe(el);});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){scan();});}else{scan();}
  document.addEventListener('shopify:section:load',function(e){scan(e.target);});
  setTimeout(function(){document.querySelectorAll(SEL).forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight&&r.bottom>0)show(el);});},2500);
})();

/* Sudara: pause looping animations while a section is off screen; small a11y fixes */
(function(){
  if(!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('sd-off',!e.isIntersecting);});},{rootMargin:'150px 0px'});
  function scan(root){(root||document).querySelectorAll('.sd,.sd-strip').forEach(function(el){if(!el.__sdo){el.__sdo=1;io.observe(el);}});}
  function a11y(){document.querySelectorAll('.sticky-add-to-cart__button').forEach(function(b){if(!b.getAttribute('aria-label'))b.setAttribute('aria-label','Add to cart');});}
  function run(){scan();a11y();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
  document.addEventListener('shopify:section:load',function(e){scan(e.target);a11y();});
  setTimeout(a11y,2000);
})();
